import {PageTemplate} from "../../shared/layout/PageTemplate";
import {TypeContent} from "./components/TypeContent";

export function Type() {
    return <PageTemplate pageName="Type" title="Enum" content={<TypeContent/>}/>
}
